var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M22.5,37.3c8.2,0,14.8-6.6,14.8-14.8S30.7,7.8,22.5,7.8S7.8,14.4,7.8,22.5S14.4,37.3,22.5,37.3z M22.5,9.8 c7.1,0,12.8,5.7,12.8,12.8c0,7.1-5.7,12.8-12.8,12.8c-7.1,0-12.8-5.7-12.8-12.8C9.8,15.5,15.5,9.8,22.5,9.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M9.8,22.5c0,7.1,5.7,12.8,12.8,12.8c7.1,0,12.8-5.7,12.8-12.8c0-7.1-5.7-12.8-12.8-12.8 C15.5,9.8,9.8,15.5,9.8,22.5z M14.2,25.2l1.5-0.5c1.9,4.9,11.8,4.9,13.7,0l1.5,0.5C28,32.2,17,32.2,14.2,25.2z M16.2,19.3 c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7C16.9,21,16.2,20.3,16.2,19.3z M25.5,19.3 c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7C26.2,21,25.5,20.3,25.5,19.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M17.8,21c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7C16.2,20.3,16.9,21,17.8,21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M27.2,21c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7C25.5,20.3,26.2,21,27.2,21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M30.8,25.2l-1.5-0.5c-1.9,4.9-11.8,4.9-13.7,0l-1.5,0.5C17,32.2,28,32.2,30.8,25.2z"
}));

function SvgHappyFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/media/happy_face.47d8a1d6d0cb8204e7f98fb9ca2437f7.svg";
export { ForwardRef as ReactComponent };